/**
 * 检查数据，当一个页面多个请求的时候，登录过期之后，只显示一个报错
 * @returns {string}
 */
import {Message} from 'element-ui';

export function check(value) {
    if (value.data.code != '0') {
        if (value.data.code != '1005') {
			// alert(value.data.code);
            Message.error(value.data.msg);
        } else {
            if (document.getElementsByClassName('el-message').length === 0) {
                Message.warning('登录时间已过期，请重新登录！');
            }
        }
        return false;
    }
    return value;
}


